import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ThriveTitle from "../../common/ThriveTitle";
import { axiosInstance } from "../../../utils/networking";

interface ProviderArchiveProp {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProviderArchive: React.FC<ProviderArchiveProp> = ({ open, setOpen }) => {
  const [archivedProviders, setArchivedProviders] = useState([]);

  useEffect(() => {
    // fetch archived providers
    axiosInstance.get(`/providers/archived`).then((res) => {
      setArchivedProviders(res.data.providers);
    });
  }, []);

  const RestoreArchivedProvider = (id: string) => () => {
    axiosInstance
      .post(`/providers/restore`, { provider_id: id })
      .then((res) => {
        window.location.reload();
      });
  };
  return (
    <Box>
      <ThriveTitle title={`Archived Providers`} setOpen={setOpen} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Organization Name</TableCell>
            <TableCell>Provider Name</TableCell>
            <TableCell>Provider Email</TableCell>
            <TableCell>Provider Phone</TableCell>
            <TableCell>Provider Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {archivedProviders.map((provider: any, index: number) => (
            <TableRow key={index}>
              <TableCell>{provider["Organization Name"]}</TableCell>
              <TableCell>
                {provider["First Name"] + " " + provider["Last Name"]}
              </TableCell>
              <TableCell>{provider["Email"]}</TableCell>
              <TableCell>{provider["Phone"]}</TableCell>
              <TableCell>
                <Button
                  sx={{ color: "#9E1F63FF" }}
                  onClick={RestoreArchivedProvider(provider["_id"])}
                >
                  Restore
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ProviderArchive;
